// auth.ts — API functions
import Cookies from "js-cookie";
import api from ".";

const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
const CLIENT_PASSWORD = import.meta.env.VITE_CLIENT_PASSWORD;
const CLIENT_TYPE = import.meta.env.VITE_CLIENT_TYPE;
const COUNTRY_CODE = import.meta.env.VITE_COUNTRY_CODE;

interface SignInParams {
  user_name: string;
  password: string;
}

export const signInUser = async ({ user_name, password }: SignInParams) => {
  const { data: clientData } = await api.post("/client-sign-in/v1", {
    client_id: CLIENT_ID,
    password: CLIENT_PASSWORD,
    client_type: "ADMIN",
  });

  if (!clientData?.accessToken) throw new Error("Failed to get client token");
  const clientToken = clientData.accessToken;

  const { data: userData } = await api.post(
    "/sign-in/v1",
    {
      user_name,
      country_code: COUNTRY_CODE,
      password,
      client_type: CLIENT_TYPE,
    },
    { headers: { Authorization: `Bearer ${clientData.accessToken}` } }
  );

  return userData;
};
export const logoutUser = async (refreshToken: string | null) => {
  const token = Cookies.get("userToken");
  if (!token) throw new Error("No token found");

  const { data } = await api.post(
    "/logout/v1",
    { refresh_token: refreshToken }, // ✅ pass refresh token
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return data;
};
